import { render } from "./info-button.vue?vue&type=template&id=10d11ebe&ts=true"
import script from "./info-button.vue?vue&type=script&lang=ts"
export * from "./info-button.vue?vue&type=script&lang=ts"

import "./info-button.vue?vue&type=style&index=0&id=10d11ebe&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__